import InstructorIndexPage from "../components/pages/instructor-management/InstructorIndexPage.vue";
import InstructorCreatePage from "../components/pages/instructor-management/InstructorCreatePage.vue";
import InstructorEditPage from "../components/pages/instructor-management/InstructorEditPage.vue";

export default [
  /** Instructor management */
  {
    path: "instructors",
    name: "instructor.index",
    component: InstructorIndexPage,
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["read-member", "crud-member"],
    },
  },
  {
    path: "instructor/add",
    name: "instructor.create",
    component: InstructorCreatePage,
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member"],
    },
  },
  {
    path: "instructor/:id/edit",
    name: "instructor.edit",
    component: InstructorEditPage,
    access: { menu: "user", subMenu: "user-mgmt" },
    meta: {
      access: { menu: "user", subMenu: "user-mgmt" },
      authRequired: true,
      permsRequired: ["crud-member"],
    },
  },
];
